import {defineComponent} from "vue";
import loginService from "@/services/login.service";
import http from "@/http-common";
import {useToast} from "vue-toastification";

export default defineComponent({
    name: "ForgetPassword",
    setup() {
        const toast = useToast();
        return {toast}
    },
    data() {
        return {
            token: null,
            resetPassword: {
                email: ""
            },
            url: '',
            incorrectCredentials: false,
            userDeactivated: false,
        };
    },
    mounted() {
        this.token = this.$route.query.token;
        this.url = process.env.BASE_URL;
        http.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;

    },
    methods: {
        onSubmit() {
            this.userDeactivated = false;
            this.incorrectCredentials = false;
            const loader = this.$loading.show();
            loginService
                .forgetPassword(this.resetPassword)
                .then((res) => {
                    loader.hide();
                    this.toast.success("A reset password email has been sent to your email, please check your email to reset your password.");

                })
                .catch((err) => {
                    loader.hide();
                    if (err.response.status == 400) {
                        this.toast.error(err.response.data.error);
                    } else {
                        this.toast.error("An error occured while trying to make the request, please try again, if problem persist, please contact our support.");
                    }


                });
        },
    },
});
